import React, { useEffect, useState } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { jwtDecode } from "jwt-decode";
import { getServerTime } from "../Services/ServerTime";

export default function Protected({ children }) {
    const location = useLocation();
    const [isAuthenticated, setIsAuthenticated] = useState(null); // null for loading state
    const [isVendor, setIsVendor] = useState(false);

    const vendorPaths = ["/vendors", "/questions", "/forgetpassword", "/otp"];

    useEffect(() => {
        const checkAuthentication = async () => {
            const from = location.pathname || "/";
            sessionStorage.setItem('from', from);

            const isVendorPath = vendorPaths.includes(location.pathname);
            setIsVendor(isVendorPath);

            if (isVendorPath) {
                localStorage.removeItem("sessionId");
                const userId = localStorage.getItem("Vendor User");
                const isValidVendor = await compareUserId(userId);
                setIsAuthenticated(isValidVendor);
            } else {
                const sessionId = localStorage.getItem("sessionId");
                setIsAuthenticated(!!sessionId);
            }
        };

        checkAuthentication();
    }, [location.pathname]); // REMOVED isAuthenticated from dependencies

    const compareUserId = async (storedUserId) => {

        try {
            const authData = localStorage.getItem("Firebase Auth");
            if (!authData) {
                return false;
            }

            const token = JSON.parse(authData)?.accessToken;
            if (!token) {
                return false;
            }

            const decodedToken = jwtDecode(String(token));
            
            const { serverTime } = await getServerTime();

            // Check if token is expired
            if (decodedToken.exp && decodedToken.exp < serverTime) {
                console.warn("Token has expired, removing Vendor User.");
                localStorage.removeItem("Vendor User");
                localStorage.removeItem("Firebase Auth");
                return false;
            }

            // Validate user ID
            if (decodedToken.user_id) {
                localStorage.setItem("Vendor User", decodedToken.user_id);
                const isMatch = storedUserId === decodedToken.user_id;
                return isMatch;
            }

            return false;
        } catch (error) {
            console.error("Error validating token:", error);
            localStorage.removeItem("Vendor User");
            localStorage.removeItem("Firebase Auth");
            return false;
        }
    };

    // Show loading while authentication is being checked
    if (isAuthenticated === null) {
        return ;
    }

    // Handle vendor authentication
    if (isVendor) {
        return isAuthenticated ? children : <Navigate to="/vendorlogin" replace />;
    }

    // Handle regular user authentication
    return isAuthenticated ? children : <Navigate to="/" replace />;
}